import React from "react";

const DarulIfta = () => {
  return (
    <div className="container my-4">
      <h2 className="display-5 fw-bold mb-3">📜 Misbahi Darul Ifta</h2>
      <h5>Ask a Question</h5>
      <form className="my-3">
        <input type="text" placeholder="Name" className="form-control my-2" />
        <input type="email" placeholder="Email" className="form-control my-2" />
        <input type="text" placeholder="Mobile No." className="form-control my-2" />
        <input type="text" placeholder="Subject" className="form-control my-2" />
        <textarea placeholder="Your Question" className="form-control my-2"></textarea>
        <button className="btn btn-primary mt-2">Submit</button>
      </form>
    </div>
  );
};

export default DarulIfta;
